<template>
  <div>
    <b-modal @hidden="$parent.closeManageVisitsEntities()" hide-footer size='lg' ref='modalManageVisits' id="modalManageVisits" title="Visitas entidades">
        <b-form>
            <b-row>
                <b-col :cols='12'>
        <div>
            <b-form-checkbox id="checkbox1"
                            v-model="inputs.showMyVisits"
                            :value="true"
                            :unchecked-value="false">
            Ver sólo mis visitas
            </b-form-checkbox>
        </div>
                </b-col>
            </b-row>
            <b-row  class='mt-3'>
                <b-col :cols='6'>
                    Entidades
                    <multiselect  placeholder="Todas" deselect-label="Click o enter para deseleccionar" select-label="Click o enter para seleccionar"
                    v-model="inputs.entity.value"
                    :options="inputs.entity.options"
                                  :multiple="false" :close-on-select="true"
                                  :clear-on-select="true" :preserve-search="true" label="name" track-by="value"
                                  :preselect-first="true">
                    </multiselect>
                </b-col>
                <b-col :cols='2'>
                  &nbsp;
                  <b-button size='lg' @click='submitFilters' :block='true' variant='primary'>
                    <i class='p-0 fa fa-search'></i>&nbsp; Buscar
                  </b-button>
                </b-col>
                <b-col :cols='2'>
                  &nbsp;
                  <b-button size='lg' :block='true' variant='default' @click="exportExcel">
                    <i class='p-0 fa fa-download'></i>&nbsp; Exportar
                    </b-button>
                </b-col>
                <b-col :cols='2'>
                  &nbsp;
                  <b-button size='lg' @click="showManageVisitsEntitiesResultsNewVisitPopup=true" :block='true' variant='secondary'>
                    <i class='p-0 fa fa-plus'></i>&nbsp; Nueva visita
                    </b-button>
                </b-col>
            </b-row>

            <hr>

            <b-row v-if='!showManageVisitsEntitiesResultsNewVisitPopup && showManageVisitsEntitiesResultsPopup'>
              <b-col :cols='12' class='mt-4'>
                <ManageVisitsEntitiesResults @delete='refreshResults()' v-if="showManageVisitsEntitiesResultsPopup" :data='resultsData' :entity='this.inputs.entity.value' ></ManageVisitsEntitiesResults>
              </b-col>
            </b-row>
            <b-row v-if='showManageVisitsEntitiesResultsNewVisitPopup'>
              <b-col :cols='12' class='mt-4'>
              <ManageVisitsEntitiesResultsNew @closed='showManageVisitsEntitiesResultsNewVisitPopup=false'></ManageVisitsEntitiesResultsNew>
              </b-col>
            </b-row>
        </b-form>

    </b-modal>

    </div>
</template>

<script>

import Vue from 'vue';

import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';

import ManageVisitsEntitiesResults from './ManageVisitsEntitiesResults';
import ManageVisitsEntitiesResultsNew from './ManageVisitsEntitiesResultsNew';

export default {
  name: 'ManageVisitsEntities',
  props: ['permisos'],
  components: {Datepicker, ManageVisitsEntitiesResults, ManageVisitsEntitiesResultsNew},
  Multiselect,
  data () {
    return {
      currentManager: {
        id: null,
        name: null
      },
      showManageVisitsEntitiesResultsPopup: false,
      showManageVisitsEntitiesResultsNewVisitPopup: false,
      resultsData: null,
      inputs: {
        showMyVisits: false,
        dateStart: {
          value: null,
          availableWeeks: []
        },
        dateEnd: {
          value: null,
          availableWeeks: []

        },
        entity: {
          value: null,
          options: []
        },
        distributor: {
          value: [],
          options: []
        }
      },
      loading: 0,
      userForm: false,
      columns: [

      ],
      modalTitle: 'Resumen visitas',
      newUser: {
        nick: '',
        email: '',
        nombre: '',
        apellidos: '',
        metadatos: ''
      }
    };
  },
  computed: {
  },
  created: function () {
    // this.populateAvailableWeeks()
    this.populateAvailableEntities();
    this.getCurrentManagerData();
  },
  mounted: function () {
    this.$refs.modalManageVisits.show();
  },
  methods: {

    refreshResults () {
      this.submitFilters();
    },

    getCurrentManagerData: function () {
      this.$http.get('tokens/' + Vue.cookie.get('kernel_token') + '/').then(response => {
        this.currentManager.id = response.data.user.username;
        this.currentManager.name = response.data.user.last_name + ', ' + response.data.user.first_name;
      });
    },

    submitFilters () {
      this.showManageVisitsEntitiesResultsNewVisitPopup = false;

      let entity = (this.inputs.entity.value !== null) ? this.inputs.entity.value.value : '';
      let createUser = this.inputs.showMyVisits === true ? this.currentManager.id : '';

      this.$http.get('visitas_entidades/?id_entidad=' + entity + '&create_user=' + createUser + '&ordering=fecha_hora_visita,fecha_hora_proxima_visita').then(response => {
        this.showManageVisitsResultsPopup = true;
        this.resultsData = response.data;
        this.showManageVisitsEntitiesResultsPopup = true;
      });
    },

    populateAvailableEntities () {
      this.$http.get('entities/').then(response => {
        let options = [];

        var data = response.body;

        for (let i = 0; i < data.length; ++i) {
          options.push({
            value: data[i]['id'],
            name: data[i]['nombre_entidad'] + '(CIF: ' + data[i]['cif'] + ') - (SAP:' + data[i]['codigo_entidad'] + ')'
          });
        }

        this.inputs.entity.options = options;

        // // LOAD ON RENDER
        // this.inputs.dateStart.value = '2018-03-03'
        // this.inputs.dateEnd.value = '2018-04-03'
        // this.inputs.distributor.value = [options[1]]
        // this.submitFilters()
      });
    },

    exportExcel () {
      var path = {name: 'Download', 'query': {'type': 'visitaentidad', 'q': ''}};
      try {
        if (this.inputs.entity.value !== null) {
          path['query']['q'] = "id_entidad='" + this.inputs.entity.value.value + "'";
        }

        if (this.inputs.showMyVisits) {
          if (path['query']['q'].length > 0) {
            path['query']['q'] += " AND create_user='" + this.currentManager.id + "'";
          } else {
            path['query']['q'] = "create_user='" + this.currentManager.id + "'";
          }
        }
      } catch (err) {}

      let routeData = this.$router.resolve(path);
      window.open(routeData.href, '_blank');
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/CommercialManagement/ManageVisitsEntities.vue